/**
 * We need polyfill for Chrome 72 support for NewRelic
 */

if (!Object.fromEntries) {
  Object.fromEntries = function (entries) {
    if (!entries || !entries[Symbol.iterator]) {
      throw new Error('Object.fromEntries() requires a single iterable argument')
    }

    const obj = {}
    for (const [key, value] of entries) {
      obj[key] = value
    }

    return obj
  }
}
